import * as React from "react";
const SvgFiRrHourglassStart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hourglass-start_svg__a)">
      <path
        fill="#062147"
        d="M16.551 12.096c2.522-2.257 4.003-4.76 4.405-7.45a3.94 3.94 0 0 0-.917-3.153A4.02 4.02 0 0 0 16.996.097h-9.99c-1.17 0-2.28.51-3.044 1.397a3.94 3.94 0 0 0-.917 3.158C3.45 7.35 4.93 9.85 7.446 12.096c-2.517 2.246-3.996 4.746-4.4 7.444a3.95 3.95 0 0 0 .916 3.158 4.01 4.01 0 0 0 3.043 1.397h9.99a4.02 4.02 0 0 0 3.043-1.396 3.94 3.94 0 0 0 .918-3.155c-.402-2.69-1.883-5.19-4.405-7.448m1.972 9.298a2.02 2.02 0 0 1-1.528.702h-9.99a2.01 2.01 0 0 1-1.528-.703 1.92 1.92 0 0 1-.456-1.556c.375-2.5 1.923-4.84 4.6-6.957a.998.998 0 0 0 0-1.568c-2.677-2.118-4.225-4.458-4.6-6.957a1.92 1.92 0 0 1 .456-1.556 2.02 2.02 0 0 1 1.528-.702h9.99c.587 0 1.144.255 1.528.702.377.438.54.99.455 1.553-.373 2.488-1.92 4.83-4.6 6.962a1.002 1.002 0 0 0 0 1.566c2.68 2.132 4.228 4.474 4.6 6.962a1.92 1.92 0 0 1-.456 1.553zM16.607 5.472a1 1 0 0 0-.927-1.376H8.317A1 1 0 0 0 7.39 5.47c.748 1.853 2.3 3.346 3.471 4.272l.52.41a1 1 0 0 0 1.244-.002l.507-.404c1.173-.933 2.728-2.431 3.475-4.275M12 8.092c-.63-.508-1.37-1.192-1.966-1.995h3.928c-.593.798-1.33 1.484-1.962 1.996"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hourglass-start_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHourglassStart;
